import { styled as StyledMui } from "@mui/system";
import { Avatar, Box, Typography } from "@mui/material";

export const ConnectionsCardContainer = StyledMui(Box)(({ theme }) => ({
  width: "35.6rem",
  height: "12rem",
  backgroundColor: "#F2F2F2",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  rowGap: "0.9rem",
  borderRadius: "0.5rem",
  cursor: "pointer",
}));

export const ConnectionsCardBox = StyledMui(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  columnGap: "2rem",
  width: "100%",
}));

export const AvatarBox = StyledMui(Box)(() => ({
  width: "7.8rem",
  display: "flex",
  justifyContent: "center",
}));

export const StyledAvatar = StyledMui(Avatar)(() => ({
  width: "6.5rem",
  height: "6.5rem",
}));

export const ConnectionsCardDataBox = StyledMui(Box)(() => ({
  width: "21rem",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

export const ConnectionsCardName = StyledMui(Typography)(({ theme }) => ({
  fontSize: "2rem",
  color: "#cf2030",
  textWrap: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  textAlign: theme.direction === "rtl" ? "right" : "left",
  whiteSpace: "nowrap",
}));

export const ConnectionsCardCategory = StyledMui(Typography)(({ theme }) => ({
  fontSize: "1.4rem",
  color: "#676767",
  textAlign: theme.direction === "rtl" ? "right" : "left",
  cursor: "default",
  textWrap: "wrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  WebkitLineClamp: "2",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
}));

export const ConnectionsCardChapter = StyledMui(Typography)(({ theme }) => ({
  fontSize: "1.4rem",
  color: "#cf2030",
  textAlign: theme.direction === "rtl" ? "right" : "left",
  cursor: "default",
}));
